var _path, _ellipse, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOnprem = function SvgOnprem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    viewBox: "0 0 29 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M21.264 20.348v1.154"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.685,
    cy: 7.224,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 10.235,
    ry: 3.954
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M14.685 17.5c-5.652 0-10.235-1.77-10.235-3.953M14.685 23.824c-5.652 0-10.235-1.77-10.235-3.954M4.45 7.22v12.694M24.92 7.224v5.997"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.167,
    height: 7.372,
    x: 16.708,
    y: 17.286,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 1.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    d: "M23.739 16.827v-.833a2.447 2.447 0 1 0-4.894 0v.832"
  })));
};
export default SvgOnprem;